import { Flex, Heading, SimpleGrid, Text } from '@chakra-ui/layout';
import { Spinner } from '@chakra-ui/spinner';
import firebase from 'firebase/app';
import moment from 'moment';
import React from 'react';
import { useCollectionData } from 'react-firebase-hooks/firestore';
import {
  FirebaseCourseWithUid,
  FirebaseCourseWithUidAndRegistration,
} from '../../../types/types';
import { AdminCourseRegistrationItem } from './AdminCourseRegistrationItem';

interface AdminRegistrationsTabProps {}

export const AdminRegistrationsTab: React.FC<AdminRegistrationsTabProps> =
  () => {
    const [courses] = useCollectionData<FirebaseCourseWithUid>(
      firebase.firestore().collection('courses'),
      { idField: 'uid' }
    );

    if (!courses)
      return (
        <Flex w="full" justify="center">
          <Spinner />
        </Flex>
      );

    const coursesWithRegistrants = courses
      .map((course) =>
        course.dates
          ? Object.keys(course.dates).map((value) => ({
              ...course,
              date: moment.unix(+value),
              registrants: course.dates![value],
            }))
          : false
      )
      .filter(Boolean)
      .flat() as FirebaseCourseWithUidAndRegistration[];

    const filteredCoursesWithRegistrants = coursesWithRegistrants
      .sort((a, b) => moment(a.date).date() - moment(b.date).date())
      .filter((course) => course.date.isAfter(moment()));

    return (
      <>
        <Heading size="md">Kurs-Registrierungen</Heading>
        <SimpleGrid columns={1} gap={4} mt={6}>
          {filteredCoursesWithRegistrants.length > 0 ? (
            filteredCoursesWithRegistrants.map((course, idx) => (
              <AdminCourseRegistrationItem
                key={idx.toString()}
                course={course}
              />
            ))
          ) : (
            <Text>Bis jetzt sind keine Registrierungen eingegangen.</Text>
          )}
        </SimpleGrid>
      </>
    );
  };
